module.exports = __webpack_public_path__ + "media/images/facebook-1e46937b6ade1de5a370b094cd3c9136.svg";